import { individualsNameColumn } from '@utils/columns';

export default t => [individualsNameColumn(t)];
